module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "data-toggle": "tooltip",
      "data-delay": "{\"show\":\"800\", \"hide\":\"100\"}",
      "title": 'title'
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c4e6c81"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tooltip.vue
// module id = 807
// module chunks = 1